import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["id"];
const _hoisted_2 = ["href"];
const _hoisted_3 = { class: "order-2 col-span-2 mx-4 mb-2 mt-4 lg:order-1 lg:col-span-1 lg:m-0" };
const _hoisted_4 = { class: "mb-5 flex items-center justify-between gap-4 border-b border-black pb-5 lg:pb-6" };
const _hoisted_5 = { class: "text-sm font-bold leading-none" };
const _hoisted_6 = { class: "!mb-0 !mt-0 text-lg" };
const _hoisted_7 = { class: "mt-2.5 flex flex-col gap-4 border-t border-black pt-5 lg:mt-3 lg:pt-6" };
const _hoisted_8 = { class: "flex items-center gap-5" };
const _hoisted_9 = { class: "size-3" };
import { useMq } from 'vue3-mq';
import { decodeHTML } from '@helpers/text';
import SignpostsImages from '@molecules/SignpostsImages.vue';
import SvgIcon from '@atoms/SvgIcon.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'EventSignpostBlock',
    props: {
        posts: {},
        title: {},
        paragraph: {},
        colorClasses: {},
        forcedRatio: { type: Boolean },
        anchor: {}
    },
    setup(__props) {
        const screen = useMq();
        const toDateString = (post) => {
            return `${post?.startDate} - ${post?.endDate}`;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                id: _ctx.anchor,
                class: "!mb-12 !mt-0 lg:!mb-24 lg:!mt-0 lg:py-0",
                "data-event-signpost-block": ""
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                    return (_openBlock(), _createElementBlock("a", {
                        href: post.url,
                        class: "grid-layout lg:container group !gap-x-0 !gap-y-3 py-10 lg:!gap-x-4"
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.title), 1)
                            ]),
                            _createElementVNode("h3", _hoisted_6, _toDisplayString(_unref(decodeHTML)(post.title)), 1),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, [
                                        _createVNode(SvgIcon, { name: "calendar" })
                                    ]),
                                    _createElementVNode("span", null, _toDisplayString(toDateString(post)), 1)
                                ])
                            ])
                        ]),
                        _createElementVNode("div", {
                            class: _normalizeClass([{ container: _unref(screen).mdMinus }, "order-1 flex flex-col gap-10 overflow-hidden md:col-span-2 md:flex-row md:gap-5 lg:order-2"])
                        }, [
                            _createVNode(SignpostsImages, {
                                forcedRatio: _ctx.forcedRatio,
                                posts: [post],
                                removeButton: true,
                                class: "group-hover:scale-105"
                            }, null, 8, ["forcedRatio", "posts"])
                        ], 2)
                    ], 8, _hoisted_2));
                }), 256))
            ], 8, _hoisted_1));
        };
    }
});
